module.exports = __webpack_public_path__ + "img/doneButton.7ebf0def.png";